import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/PE.svg";
var PeOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  PeOutline_default as default
};
